
    import './styles.scoped.css';
    export default {
  "placeholder": "awsui_placeholder_dwuol_wz8sk_145",
  "item": "awsui_item_dwuol_wz8sk_150",
  "checkbox": "awsui_checkbox_dwuol_wz8sk_154",
  "filter": "awsui_filter_dwuol_wz8sk_163",
  "trigger": "awsui_trigger_dwuol_wz8sk_168",
  "layout-strut": "awsui_layout-strut_dwuol_wz8sk_174",
  "list-bottom": "awsui_list-bottom_dwuol_wz8sk_180",
  "selected-icon": "awsui_selected-icon_dwuol_wz8sk_184",
  "show-label-tag": "awsui_show-label-tag_dwuol_wz8sk_188",
  "inline-token-trigger": "awsui_inline-token-trigger_dwuol_wz8sk_192",
  "inline-token-list": "awsui_inline-token-list_dwuol_wz8sk_199",
  "inline-token": "awsui_inline-token_dwuol_wz8sk_192",
  "visual-refresh": "awsui_visual-refresh_dwuol_wz8sk_229",
  "inline-token-hidden-placeholder": "awsui_inline-token-hidden-placeholder_dwuol_wz8sk_236",
  "inline-token-counter": "awsui_inline-token-counter_dwuol_wz8sk_242",
  "inline-token-trigger--disabled": "awsui_inline-token-trigger--disabled_dwuol_wz8sk_246",
  "inline-label-trigger-wrapper": "awsui_inline-label-trigger-wrapper_dwuol_wz8sk_252",
  "inline-label-wrapper": "awsui_inline-label-wrapper_dwuol_wz8sk_256",
  "inline-label": "awsui_inline-label_dwuol_wz8sk_252",
  "disabled-reason-tooltip": "awsui_disabled-reason-tooltip_dwuol_wz8sk_282"
};
  